/** Default-off tenant opt-in. Global values never enable publication unblock. */
export const ROSTER_PUBLISH_UNBLOCK_FLAG = 'roster_publish_unblock_v1';
export const isTenantScopedRosterPublishUnblockFlag = (key: string | null | undefined) =>
  key === ROSTER_PUBLISH_UNBLOCK_FLAG;
